import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useNfeModalStore } from './NfeModalStore'
import {
  NfeResponse,
  useDownloadOrderNFE,
  useDownloadOrderNFEs
} from 'modules/orders/hooks'
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload'
import { ListItemIcon, ListItemText, MenuItem, MenuList } from '@mui/material'
import { formatCurrency, formatDate } from 'utils'
import { Loading } from 'components'

type Props = {
  open?: boolean
  text?: string
  title?: string
  okButtonLabel?: string
  cancelButtonLabel?: string
  buttonLabel?: string
  onClose?: (ok: boolean) => void
}

const NfeItem = ({ nfe, orderId }: { orderId: string; nfe: NfeResponse }) => {
  const { mutate, isLoading: isDownloading } = useDownloadOrderNFE()

  const handleClick = (nfe: NfeResponse) => {
    mutate({ orderId, nfeId: nfe.nfeId })
  }

  return (
    <MenuItem onClick={() => handleClick(nfe)} disabled={isDownloading}>
      <ListItemIcon>
        <SimCardDownloadIcon />
      </ListItemIcon>
      <ListItemText
        primary={`${nfe.nfeName}`}
        secondary={`${formatDate(nfe.date)} - ${formatCurrency(nfe.total)}`}
      />
    </MenuItem>
  )
}

export function NfeModal(props: Props) {
  const { cancelButtonLabel = 'fechar', buttonLabel, onClose } = props

  const orderId = useNfeModalStore.useOrderId()
  const isOpen = useNfeModalStore.useIsModalOpen()
  const setOpen = useNfeModalStore.useSetModalIsOpen()

  const { data, isFetching } = useDownloadOrderNFEs(orderId)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = (ok: boolean) => {
    setOpen(false)
    onClose?.(ok)
  }

  return (
    <div>
      {buttonLabel && (
        <Button variant="outlined" onClick={handleClickOpen}>
          {buttonLabel}
        </Button>
      )}
      <Dialog open={isOpen} onClose={handleClose} maxWidth="md">
        <DialogTitle>
          {"NF's PEDIDO:"} {orderId}
        </DialogTitle>
        <DialogContent>
          {isFetching && <Loading />}
          <MenuList>
            {data?.data?.map((nfe) => (
              <NfeItem key={nfe.nfeName} nfe={nfe} orderId={orderId} />
            ))}
          </MenuList>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)}>
            {cancelButtonLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
